// extracted by mini-css-extract-plugin
export default {"navigation_box":"index_navigation_box_tHpdc","navigation":"index_navigation_IYk2g clearfix"};